// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__38SL2","head":"Table_head__2c8MI","col":"Table_col__377et"};